export interface MedalTier {
    name: string;
    minRank: number;
    maxRank: number;
    sizeMultiplier: number;
    hasAccent: boolean;
    label: string;
    tierColor: string;
}

export const MEDAL_TIERS: MedalTier[] = [
    { name: 'gold', minRank: 1, maxRank: 10, sizeMultiplier: 1.19, hasAccent: true, label: 'Guld', tierColor: '#b89530' },
    { name: 'red', minRank: 11, maxRank: 50, sizeMultiplier: 1.11, hasAccent: false, label: 'Rod', tierColor: '#8c2e2e' },
    { name: 'pink', minRank: 51, maxRank: 100, sizeMultiplier: 1.06, hasAccent: false, label: 'Pink', tierColor: '#7d2e5e' },
    { name: 'purple', minRank: 101, maxRank: 200, sizeMultiplier: 1.0, hasAccent: false, label: 'Lilla', tierColor: '#5a3280' },
    { name: 'blue', minRank: 201, maxRank: 350, sizeMultiplier: 0.93, hasAccent: false, label: 'Bla', tierColor: '#2e4c82' },
    { name: 'lightblue', minRank: 351, maxRank: 500, sizeMultiplier: 0.88, hasAccent: false, label: 'Lyseblaa', tierColor: '#3a5a6a' },
    { name: 'gray', minRank: 501, maxRank: Infinity, sizeMultiplier: 0.81, hasAccent: false, label: 'Graa', tierColor: '#666' },
];

export function getTier(rank: number): MedalTier {
    return MEDAL_TIERS.find(t => rank >= t.minRank && rank <= t.maxRank) || MEDAL_TIERS[6];
}

export function getPercentile(rank: number, totalPlayers: number): number {
    if (totalPlayers <= 0) return 0;
    return Math.round(((totalPlayers - rank + 1) / totalPlayers) * 100);
}

export function getTopPercent(rank: number, totalPlayers: number): string {
    if (totalPlayers <= 0) return '-';
    const pct = (rank / totalPlayers) * 100;
    if (pct < 1) return `Top ${pct.toFixed(1)}%`;
    return `Top ${Math.round(pct)}%`;
}

export const STAT_LABELS: Record<string, { short: string; full: string }> = {
    KD: { short: 'K/D', full: 'Kill/Death Ratio' },
    hltv2Rating: { short: 'Rtg 2.0', full: 'HLTV Rating 2.0' },
    ADR: { short: 'ADR', full: 'Avg Damage / Round' },
    HS: { short: 'HS%', full: 'Headshot %' },
    KAST: { short: 'KAST', full: 'KAST%' },
    openingDuelWinPercentage: { short: 'OPW%', full: 'Opening Duel Win%' },
};

export const STAT_ORDER = ['KD', 'hltv2Rating', 'ADR', 'HS', 'KAST', 'openingDuelWinPercentage'];
